export default {
  SET_CONFIGS(state, configs) {
    state.configs = configs;
  },

  SET_CONFIG(state, updatedConfig) {
    const index = state.configs.collection.findIndex((c) => c.id === updatedConfig.id);
    if (index >= 0) {
      state.configs.collection.splice(index, 1, updatedConfig);
    }
  },

  SET_EDITING_CONFIG(state, config) {
    state.editingConfig = config;
  },

  SET_LOADING(state, value) {
    state.loading = value;
  },

  SET_PAGE(state, page) {
    state.page = page;
  },

  SET_SORT_BY(state, sortBy) {
    state.sortBy = sortBy;
  },

  SET_ORDER_BY(state, orderBy) {
    state.orderBy = orderBy;
  },

  SET_SEARCH(state, search) {
    state.search = search;
  },
};
